export function UltimateNeutralScorekeeperIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 6l4 8h8l-6 6 2 8-8-4-8 4 2-8-6-6h8z" />
      <circle cx="24" cy="36" r="6" />
      <path d="M21 36l2 2 4-4" />
    </svg>
  );
}
